<template>
  <div class="BarcodeSerial">
    <div :style="{ margin: boxMargin }">
      <div class="w-full h-full">
        <span class="desc align-center">
          {{data.product_name}} -
          {{data.code}}
        </span>
        <div class="barcode">
          <div class="of-hidden align-center">
            <VueBarcode 
              v-bind:value="data.code" 
              height="60" 
              margin="0" 
              :width="3.5"
              :displayValue="false"
            />
          </div>
        </div>      
      </div>
    </div>
  </div>
</template>
<script>
import VueBarcode from 'vue-barcode';

export default {
  name: "BarcodeSerial",
  components: {VueBarcode},
  data() {
    return {}
  },
  props: {
    config: {
      type: Object,
      default: function() {
        return {
          margin_left: 0,
          margin_top: 0,
        }
      }
    },
    data: {
      type: Object,
      required: true,
    },
  },  
  computed: {
    boxMargin() {
      let margin_top = this.config.margin_top ? this.config.margin_top + "px" : 0;
      let margin_left = this.config.margin_left ? this.config.margin_left + "px" : 0;
      return "" + margin_top + " 0 0 " + margin_left;
    },
  },
}
</script>
<style lang="scss" scoped>
.BarcodeSerial {
  width: 385px;
  height: 110px;
  padding: 5px;    
  margin: 0;
  
  .desc {
    font-size: 12pt;
    display: block;
    margin-top: 5pt;
    margin-bottom: 5pt;
  }
  .barcode {
    height: 60px;
    >div {
      padding-left: 10px;
    }
  }
}
</style>
<style type="text/css" media="print"> 
.BarcodeSerial {
  size:70mm 20mm; margin: 0;
  font-family: "돋움";
  page-break-after: always;
} 
</style>